import DealerApi from 'api/dealer';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import SummaryReport from './components/summaryReport';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

const render = (container) => {
  console.info('[UI.page.reports] rendering page');
  ReactDOM.render(<IntlWrapper><LandingReports /> </IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports] register route');
router.rr.add([{path: 'reports/', handler: routeUtils.requireAdmin(render)}]);

class _LandingReports extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      stores: [],
      loaded: false,
    };
  }

  componentDidMount() {
    this.getUser()
      .then(res => {
        this.setState({
          blocks: this.getBlocks(),
        });
      })
      .then(() => {
        this.getDealer();
      });
  }

  /* ========================================================================
   * Get the block array
   * ======================================================================== */
  getBlocks = () => {
    let {formatMessage} = this.props.intl;

    let blocks = [
      {
        title: formatMessage({id: 'reports.followups'}),
        description: formatMessage({id: 'reports.followups.description'}),
        dataKey: 'followups',
        icon: 'bl-myfollowups_report-small',
        buttons: [
          {link: '/#reports/followups/missing-customers', label: formatMessage({id: 'reports.followups.missing.customers'})},
          {link: '/#reports/followups/problem-follow-ups', label: formatMessage({id: 'reports.problem.followups.title'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.customer.accounts'}),
        dataKey: 'customer',
        description: formatMessage({id: 'reports.customer.description'}),
        icon: 'bl-customer_report-small',
        buttons: [
          {link: '/#reports/customer/account-list', label: formatMessage({id: 'reports.customer.all.accounts'})},
          {link: '/#reports/customer/system-list', label: formatMessage({id: 'reports.customer.all.systems'})},
          {link: '/#reports/customer/missing-information', label: formatMessage({id: 'reports.customer.missing.information'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.water.analyses'}),
        description: formatMessage({id: 'reports.water.analyses.description'}),
        dataKey: 'water',
        icon: 'bl-mywateranalysis_report-small',
        buttons: [
          {link: '/#reports/water/total-water-analyses', label: formatMessage({id: 'general.total.water.analyses'})},
          {link: '/#reports/water/analysis-accounts', label: formatMessage({id: 'general.water.analysis.accounts'})},
          {link: '/#reports/water/analyses-by-employee', label: formatMessage({id: 'general.analyses.employee'})},
          // Hide per no longer support since January 1st 2020
          // {link: '/#reports/water/trublue-claims', label: formatMessage({id: 'trublue.claims.name'}), truBlueOnly: true},
        ],
      },
      {
        title: formatMessage({id: 'reports.bioguard.products'}),
        description: formatMessage({id: 'reports.bioguard.products.description'}),
        dataKey: 'followUp',
        icon: 'bl-mybioguardproducts_report-small',
        buttons: [
          {link: '/#reports/bioguard/recommended-products', label: formatMessage({id: 'reports.products.recommended'})},
          {link: '/#reports/bioguard/season-usage', label: formatMessage({id: 'reports.season.usage'})},
        ],
      },
      {
        title: formatMessage({id: 'reports.communications'}),
        description: formatMessage({id: 'reports.communications.description'}),
        dataKey: 'communications',
        icon: 'bl-mycommunications_report-small',
        buttons: [
          {link: '/#reports/communications/outbound-emails', label: formatMessage({id: 'reports.communications.outbound.emails'})},
          {link: '/#reports/communications/optout-emails', label: formatMessage({id: 'reports.communications.optout.emails'})},
        ],
      },
    ];

    return blocks;
  };


  getDealer = () => {
    DealerApi.getDealer(session.getUser().dealerId)
      .then(res => {
        this.setState({
          dealer: res,
          loaded: true,
          user: session.getUser(),
        });
      });
  };

  getPOSBlocks = (blocks) => {

    if(this.checkPOSPermission()) {
      let {formatMessage} = this.props.intl;

      var lastTile = blocks[3].buttons.pop();

      blocks[3].buttons.push({link: '/#reports/bioguard/missed-products', label: formatMessage({id: 'reports.missed.product.sales'}), posOnly: true});
      blocks[3].buttons.push(lastTile);
    }

    return blocks;
  };

  getUser = () => {
    session.getUser();
    return new Promise(function(resolve, reject) {
      (function waitUser() {
        if (session.getUser()) {
          return resolve();
        }
        setTimeout(waitUser, 30);
      })();
    });
  };

  checkPOSPermission = () => {
    const {user, dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    if (user && dealer) {
      if (user && dealer && dealer.CurrentPOSIntegration === 0) {
        return false;
      }

      if (user.isDealerAdmin) {
        return true;
      }

      if (user.isAdmin && dealer.managerDetailedReporting) {
        return true;
      }

      if (user.isTestStation && dealer.testerDetailedReporting) {
        return true;
      }
    }

    return false;
  };


  checkTruBlueDealerStatus = () => {
    const {dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    return dealer && dealer.isTruBlueEligible;
  };

  render() {

    let blocks = this.getBlocks();

    blocks = this.getPOSBlocks(blocks);

    return (
      <div className='container'>
        <Header mainTitle={this.props.intl.formatMessage({id: 'reports.title'})} />
        <span className='title-description'><FormattedMessage id='reports.description' /></span>
        <div id='page-reports'>
          {
            blocks !== undefined && blocks !== null ?
              blocks.map(b => {
                return (
                  <SummaryReport
                    POS={this.checkPOSPermission()}
                    truBlue = {this.checkTruBlueDealerStatus()}
                    key={b.dataKey}
                    title={b.title}
                    icon={b.icon}
                    description={b.description}
                    buttons={b.buttons}
                    tooltip={b.tooltip}/>
                );
              }) :
              null
          }
        </div>
      </div>
    );
  }
}

const LandingReports = injectIntl(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_LandingReports));

export default LandingReports;
